export default "__VITE_ASSET__DGAI1Swg__"